import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import { initializeApp } from 'firebase/app';  // Firebase App
import { getDatabase, ref, get, set, child, onValue } from 'firebase/database';   // For Realtime Database
import { getAuth } from 'firebase/auth';  // For Authentication
import { getFirestore } from 'firebase/firestore';  // For Firestore
import { getStorage } from 'firebase/storage';  // For Storage

const firebaseConfig = {
  apiKey: "AIzaSyC9eAujjDx0t1i5oXcA5GI2Xq43hdAmqdA",
  authDomain: "digitalsharing-83028.firebaseapp.com",
  databaseURL: "https://digitalsharing-83028-default-rtdb.firebaseio.com",
  projectId: "digitalsharing-83028",
  storageBucket: "digitalsharing-83028.firebasestorage.app",
  messagingSenderId: "361821676315",
  appId: "1:361821676315:web:322907605524c76a8f29be",
  measurementId: "G-6J0QF89D1R"
};
export const databaseURL = firebaseConfig.databaseURL;

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize individual Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export { app, db, ref, get, set, child, onValue, auth, firestore, storage };
export default firebase;
